"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="node" />
class Configuration {
    static environment() {
        if (Configuration.appUrl().includes("localhost")) {
            return this.LOCAL;
        }
        else if (Configuration.appUrl().includes("vacasastage.")) {
            return this.STAGING;
        }
        else if (Configuration.appUrl().includes("vacasa.")) {
            return this.PRODUCTION;
        }
        return this.LOCAL;
    }
    static appUrl() {
        const { REACT_APP_APP_URL } = process.env;
        return REACT_APP_APP_URL;
    }
    static adminUrl() {
        const { REACT_APP_ADMIN_URL } = process.env;
        return REACT_APP_ADMIN_URL;
    }
    static connectUrl() {
        const { REACT_APP_CONNECT_URL } = process.env;
        return REACT_APP_CONNECT_URL;
    }
    static vacasaIdpDomain() {
        const { REACT_APP_VACASA_IDP_DOMAIN } = process.env;
        return REACT_APP_VACASA_IDP_DOMAIN;
    }
    static idpRedirectUri() {
        const { REACT_APP_IDP_REDIRECT_URI } = process.env;
        return REACT_APP_IDP_REDIRECT_URI;
    }
    static idpClientId() {
        const { REACT_APP_IDP_CLIENT_ID } = process.env;
        return REACT_APP_IDP_CLIENT_ID;
    }
    static unitsServiceConfig() {
        const { REACT_APP_UNIT_APP_IDP_AUDIENCE, REACT_APP_UNIT_APP_API, REACT_APP_CONNECT_AUDIENCE } = process.env;
        // Fix for the MUL SPA that uses two audiences, it can be improved, but we would need to refactor the ConnectToServices component
        let audience = `${REACT_APP_UNIT_APP_IDP_AUDIENCE}`;
        if (REACT_APP_CONNECT_AUDIENCE) {
            audience = `${audience} ${REACT_APP_CONNECT_AUDIENCE}`;
        }
        return {
            api: REACT_APP_UNIT_APP_API,
            audience: audience,
            apiV2: `${REACT_APP_UNIT_APP_API}/api/v2`,
            apiV3: `${REACT_APP_UNIT_APP_API}/api/v3`,
        };
    }
    static adminConfig() {
        const { REACT_APP_PUBLIC_KEY_FROM_ADMIN, REACT_APP_ADMIN_URL } = process.env;
        return { publicKey: REACT_APP_PUBLIC_KEY_FROM_ADMIN, url: REACT_APP_ADMIN_URL };
    }
    static housekeeperConfig() {
        const { REACT_APP_CUSTOM_SCOPE } = process.env;
        return { customScopes: REACT_APP_CUSTOM_SCOPE };
    }
    static localAuthToken() {
        const { REACT_APP_LOCAL_AUTHTOKEN } = process.env;
        if (Configuration.environment() !== Configuration.LOCAL)
            return;
        return REACT_APP_LOCAL_AUTHTOKEN;
    }
    static localAdminInfo() {
        const { REACT_APP_LOCAL_INFOFROMADMIN } = process.env;
        if (Configuration.environment() !== Configuration.LOCAL || !REACT_APP_LOCAL_INFOFROMADMIN)
            return;
        try {
            return JSON.parse(REACT_APP_LOCAL_INFOFROMADMIN);
        }
        catch (error) {
            console.log("error parsin local InfoFromAdmin");
            console.log(error);
            return false;
        }
    }
}
exports.Configuration = Configuration;
Configuration.LOCAL = "local";
Configuration.STAGING = "staging";
Configuration.PRODUCTION = "production";
Configuration.BED = {
    CRIB: {
        SIZE_ID: 6,
        TYPE_ID: 10,
    },
    CHILD: {
        SIZE_ID: 5,
        TYPE_ID: 9,
    },
};
Configuration.BEDROOM_TYPE = {
    BEDROOM: { ID: 8 },
    UNASSIGNED: { ID: 10 },
};
Configuration.PROVIDER_NAME = {
    INSIDEMAPS: "InsideMaps",
    MATTERPORT: "Matterport",
};
Configuration.MATTERPORT_PATH = "https://my.matterport.com/show/?m=";
Configuration.UNIT_IMAGES_CACHE_KEY = "units_images_cache";
//# sourceMappingURL=configuration.js.map